import SpriteSymbol from "../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-back",
  "use": "arrow-back-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" viewBox=\"0 0 48 48\" id=\"arrow-back\">\n  <path d=\"M44 22v4H11.829l7.585 7.586-2.828 2.828L4.17 24l12.415-12.414 2.828 2.828L11.828 22Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol